import styled from 'styled-components'

import { helpers } from '../../../../styles/theme'

type Props = {
	isSmall: boolean
}

export const Container = styled.div<Props>`
	font-family: ${helpers.font.family.base};
	font-size: ${({ isSmall }) => (isSmall ? '13px' : '15px')};
	background-color: ${helpers.color.input.menuBackground};
	border-radius: 4px;
	overflow-y: auto;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	border: 1px solid ${helpers.color.input.menuBorder};
	transition: opacity 200ms ease;
	max-height: 350px;
	padding: 6px 0;
	scrollbar-width: thin;
	z-index: 10;

	&::-webkit-scrollbar {
		background-color: transparent;
		margin-left: -8px;
		border-radius: 0 4px 4px 0;
	}
`
